import React from "react";
import { FaStar } from "react-icons/fa";
import { FcGoogle } from "react-icons/fc";

const labels = {
    sl: {
        ariaLabel:
            "Povprečna ocena 4,8 od 5 zvezdic. Prikaži mnenja obiskovalcev.",
        text: "Povprečna ocena",
    },
    en: {
        ariaLabel:
            "Average rating 4.8 out of 5 stars. Show visitor reviews.",
        text: "Google reviews",
    },
};

function GoogleRatingBadge({ locale = "sl", className = "" }) {
    const label = labels[locale] || labels.sl;

    function scrollToReviews(event) {
        const heading = document.getElementById("google-reviews-title");

        if (!heading) {
            return;
        }

        event.preventDefault();
        const reviewsSection = heading.closest("section");
        (reviewsSection || heading).scrollIntoView({
            behavior: "smooth",
            block: "start",
        });
    }

    return (
        <a
            className={`google-rating-badge ${className}`.trim()}
            href="#google-reviews-title"
            onClick={scrollToReviews}
            aria-label={label.ariaLabel}
        >
            <FcGoogle aria-hidden="true" />
            <span
                className="google-rating-badge__stars"
                aria-hidden="true"
            >
                {[0, 1, 2, 3, 4].map((star) => (
                    <FaStar key={star} />
                ))}
            </span>
            <strong>4.8</strong>
            <span>{label.text}</span>
        </a>
    );
}

export default GoogleRatingBadge;
